import {
    AutoComplete,
    Button, Col, Divider, Drawer, Form, Input,
    InputNumber,
    Modal,
    Popconfirm,
    Row,
    Select,
    Table,
    Tooltip,
    Upload,
    UploadFile, notification
} from 'antd';
import { Option } from 'antd/es/mentions';
import { ColumnsType } from "antd/es/table";
import { RcFile, UploadProps } from 'antd/es/upload';
import { useEffect, useState } from 'react';
import { Link } from "react-router-dom";
import { Icon } from 'ts-react-feather-icons';
import { ActionType } from '../../constants/actionType';
import { searchStory } from '../../helpers/api/story';
import { fetchCollectionConfigs } from '../../helpers/api/storyCollectionConfig';
import { createCollection, updateCollection } from '../../helpers/api/storyCollections';
import { StoryModel } from '../../pages/storyCollection/StoryCollectionDetail';

const storyCollectionDrawerValidation = {
    name: [
        {required: true, message: 'Name is required'},
        {max: 100, message: 'Name must be less than 100 characters'},
    ],
    dayIndexMin: [
        {required: true, message: 'Day MIN is required'},
    ],
    dayIndexMax: [
        {required: true, message: 'Day MAX is required'},
    ],
    config: [
        {required: true, message: 'Config is required'},
    ],
}

const StoryCollectionDrawer = ({
                         drawerVisibility,
                         setdDrawerVisibility,
                         storyCollectionDetail,
                         setStoryCollectionDetail,
                         allStoryCollections,
                         categories,
                         actionType,
                         setActionType,
                         onSuccess,
                         onFailure
                     }: any) => {

    const [form] = Form.useForm();
    const formValueObj = Form.useWatch([], form);

    const [submittables, setSubmittable] = useState<boolean>(false);
    const [loadingBtn, setLoadingBtn] = useState<boolean>(false);

    const [ stories, setStories ] = useState<StoryModel[]>([]);
    const [ collectionStories, setCollectionStories ] = useState<any[]>([]);
    const [previewOpen, setPreviewOpen] = useState(false);
    const [previewImage, setPreviewImage] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [images, setImages] = useState<UploadFile[]>([]);
    const [ collectionConfigs, setCollectionCongigs ] = useState<any[]>([]);
    const [ currentConfig, setCurrentConfig ] = useState<any>(null);
    
    useEffect(() => {
        fiterCollectionStories();
        getCollectionConfigs();
    }, []);

    useEffect(() => {
        if (storyCollectionDetail) {
            form.setFieldValue("name", storyCollectionDetail.name);
            form.setFieldValue("subTitle", storyCollectionDetail.subTitle);
            form.setFieldValue("description", storyCollectionDetail.description);

            const config = collectionConfigs.find((item: any) => item.id === storyCollectionDetail.config.id);
            setCurrentConfig(config);

            const collectionStories = stories.filter(s => storyCollectionDetail.storyIds.includes(s.id));
            setCollectionStories(collectionStories);
            if (storyCollectionDetail?.imageUrl) {
                const urlTemp = storyCollectionDetail?.imageUrl?.split("/");
                setImages([{
                    uid: "1",
                    name: urlTemp[urlTemp.length - 1],
                    status: 'done',
                    url: storyCollectionDetail?.imageUrl
                }]);
            }
            return;
        }
    }, [storyCollectionDetail]);

    const [api, contextHolder] = notification.useNotification();

    useEffect(() => {
        form.validateFields({validateOnly: true})
            .then(
                () => {
                    setSubmittable(true)
                },
                () => {
                    setSubmittable(false)
                },
            );
    }, [formValueObj]);

    useEffect(() => {
        form.setFieldValue("configName", currentConfig?.name );
        form.setFieldValue("dayIndexMin", currentConfig?.config?.dayIndexMin);
        form.setFieldValue("dayIndexMax", currentConfig?.config?.dayIndexMax );
    }, [currentConfig])

    const getBase64 = (file: RcFile): Promise<string> =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result as string);
            reader.onerror = (error) => reject(error);
        });

    const handleCancel = () => setPreviewOpen(false);

    const showError = (errorMessage: string) => {
        api.error({
            message: `Error notification`,
            description: <span className="text-danger">{errorMessage || 'There\'re some errors occured!'}</span>,
            placement: 'topRight'
        });
    }

    const handlePreview = async (file: UploadFile) => {
        if (!file.url && !file.preview) {
            file.preview = await getBase64(file.originFileObj as RcFile);
        }

        setPreviewImage(file.url || (file.preview as string));
        setPreviewOpen(true);
        setPreviewTitle(file.name || file.url!.substring(file.url!.lastIndexOf('/') + 1));
    };

    const handleChange: UploadProps['onChange'] = ({ fileList: newFileList }) => {
        setImages(newFileList);
    }

    const triggerDeleteStory = async (storyModel: StoryModel) => {
        try {
            if (!storyModel || !storyModel?.id) {
                return;
            }
            let newCollectionStories = [ ...collectionStories ];
            newCollectionStories = newCollectionStories.filter((story) => story.id !== storyModel.id);
            setCollectionStories(newCollectionStories);
        } catch (err) {
            console.error(err);
            showError(err as string);
        }
    }

    const uploadButton = (
        <div>
            <Icon name="plus" size={16}/>
            <div style={{marginTop: 8}}>Upload</div>
        </div>
    );

    const fiterCollectionStories = async () => {
        try {
            const searchObj: any = {
              pageIndex: 0,
              pageSize: 300,
              types: 'collection_item',
            };

            if (storyCollectionDetail) {
                searchObj.storyIds = storyCollectionDetail.storyIds;
            }
            const res = await searchStory(searchObj);
            setStories(res.data.data);
          } catch (err) {
            console.error(err);
            // showError(err as string);
          }
    }

    const getCollectionConfigs = async () => {
        try {
            const res = await fetchCollectionConfigs();
            console.log('response', res);
            // const activatedConfigs = res.data.filter((item: any) => item.status === "active");
            setCollectionCongigs(res.data);
        } catch (err) {
            console.error(err);
            // showError(err as string);
        }
    }

    const onClose = () => {
        form.resetFields();
        setStoryCollectionDetail(null);
        setSubmittable(false);
        setdDrawerVisibility(false);
        setCollectionStories([]);
        setCurrentConfig(null);
    }

    const handleSelectStory = (value: string, story: StoryModel) => {
        const inUsed = allStoryCollections.find((collection: any) => {
            return collection?.storyIds?.includes(story.id);
        }) ? true : false;

        setCollectionStories([ ...collectionStories, { ...story, inUsed} ]);
    }

    const handleSelectConfig = (configId: string) => {
        const config = collectionConfigs.find((item: any) => item.id === configId);
        setCurrentConfig(config);
    }

    const saveStoryCollection = async () => {
        try {
            form.validateFields();
            if (collectionStories.length === 0) {
                api.error({
                    message: `Error notification`,
                    description: <span className="text-danger">{'Stories is required!'}</span>,
                    placement: 'topRight'
                });
                return;
            }
            setLoadingBtn(true)

            const createCollectionRequest: any = {
                name: formValueObj.name?.trim(),
                description: formValueObj.description?.trim(),
                configId: currentConfig.id,
                subTitle: formValueObj.subTitle?.trim(),
                storyIds: collectionStories.map((item: StoryModel) => item.id),
                status:  actionType === ActionType.CREATE ? 'inactive' : storyCollectionDetail.status
            };

            let response;

            if (actionType === ActionType.CREATE) {
                response = await createCollection({
                    data: JSON.stringify(createCollectionRequest),
                    image: images.length > 0 ? images?.[0]?.originFileObj : null
                });
            } else if (actionType === ActionType.UPDATE) {
                const requestBody: any = {};
                if (images?.[0] && images?.[0].url !== storyCollectionDetail?.imageUrl) {
                    requestBody["image"] = images?.[0]?.originFileObj;
                }
                requestBody["data"] = JSON.stringify(createCollectionRequest);
                response = await updateCollection(storyCollectionDetail.id, requestBody);
            }
            setLoadingBtn(false);
            if (response?.status === 200) {
                onSuccess();
                onClose();
                return;
            }
        } catch (err) {
            console.log(err);
            onFailure(err);
        } finally {
            setImages([]);
        }
        setLoadingBtn(false);
    }

    const columns: ColumnsType<any> = [
        {
            title: "No.",
            render: (text, record, index) => {
                return (
                    <span>{index + 1}</span>
                )
            },
        },
        {
            title: "Name",
            dataIndex: "name",
            render: (text, record, index) => {
                return (
                    <Link to={`/stories/${record.id}`} className="text-primary">
                        {record.name}
                        <br/>
                        {record?.inUsed ? <span className="text-danger"> (In used)</span> : ''}
                    </Link>
                )
            },
        },
        {
            title: "Created by",
            dataIndex: "createdBy",
        },
        {
            title: "Created at",
            dataIndex: "createdAt",
            render: (text, record, index) => {
                return <span>{record?.createdAt ? new Date(record?.createdAt).toLocaleString() : ''}</span>
            }
        },
        {
            title: "Modified by",
            dataIndex: "modifiedBy",
        },
        {
            title: "Action",
            dataIndex: "action",
            width: 80,
            render: (text, record, index) => {
                return (
                    <>
                        <Tooltip title="Delete">
                            <Popconfirm
                                title={`Delete story`}
                                description={`Are you sure to delete this story?`}
                                onConfirm={() => triggerDeleteStory(record)}
                                okText="OK"
                                cancelText="Cancel"
                            >
                                <span role="button">
                                    <Icon name="trash-2" color="#dc3545" size={16}/>
                                </span>
                            </Popconfirm>
                        </Tooltip>
                    </>
                );
            },
        },
    ];

    return (
        <Drawer
            title={(actionType === ActionType.UPDATE ? "Update" : "Create") + " Collection"}
            className='story-drawer'
            width={750}
            onClose={() => {
                if (actionType === ActionType.CREATE) {
                    setdDrawerVisibility(false)
                } else {
                    onClose();
                }
            }}
            open={drawerVisibility}
            closeIcon={false}
            footer={
                <div className='d-flex justify-content-center'>
                    <Button
                        onClick={saveStoryCollection}
                        type="primary"
                        className='me-3'
                        disabled={!submittables}
                        loading={loadingBtn}>
                        Save
                    </Button>
                    <Button onClick={onClose}>Cancel</Button>
                </div>
            }
        >
            {contextHolder}
            <Form layout="vertical" autoComplete='off' form={form}>
                <Divider orientation="left" className='text-danger'>01. COLLECTION INFORMATION</Divider>
                <Row gutter={16} className='d-flex justify-content-center'>
                    <Form.Item
                        name="image"
                        label="Image"
                    >
                        <Upload
                            listType="picture-card"
                            fileList={images}
                            onPreview={handlePreview}
                            onChange={handleChange}
                            multiple={false}
                            accept="image/png, image/jpeg, image/jpg"
                        >
                            {images.length >= 1 ? null : uploadButton}
                        </Upload>
                        <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
                            <img alt="example" style={{width: '100%'}} src={previewImage}/>
                        </Modal>
                    </Form.Item>
                </Row>
                <Row gutter={16} className='mb-3'>
                    <Col span={24}>
                        <Form.Item
                            name="name"
                            label="Collection Name"
                            rules={storyCollectionDrawerValidation.name}
                        >
                            <Input placeholder="Please enter Collection Name" style={{width: "100%"}}/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="subTitle"
                            label="Subtitle"
                        >
                            <Input placeholder="Please enter SubTitle" style={{width: "100%"}}/>
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="description"
                            label="Collection Description"
                        >
                            <Input placeholder="Please enter collection description" style={{width: "100%"}}/>
                        </Form.Item>
                    </Col>
                </Row>

                <Divider orientation="left" className='text-danger'>02. CHOOSE CONFIG</Divider>

                <Row gutter={16} className='mb-3'>
                    <Form.Item
                            name="config"
                            label="Config"
                    >
                        <Select
                            placeholder="Please choose the model"
                            allowClear
                            onChange={(value) => handleSelectConfig(value) }
                        >
                            {collectionConfigs && collectionConfigs.map((item: any) => (
                                <Option
                                    disabled={item.status === 'inactive'}
                                    value={item.id}>
                                    {item.name}
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Col span={24}>
                        <Form.Item
                            name="configName"
                            label="Config name"
                            rules={storyCollectionDrawerValidation.config}
                        >
                            <Input disabled style={{width: "100%"}} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="dayIndexMin"
                            label="Day MIN"
                        >
                            <InputNumber disabled style={{width: "100%"}} />
                        </Form.Item>
                    </Col>
                    <Col span={24}>
                        <Form.Item
                            name="dayIndexMax"
                            label="Day MAX"
                        >
                            <InputNumber disabled style={{width: "100%"}} />
                        </Form.Item>
                    </Col>
                </Row>

                <Divider orientation="left" className='text-danger'>03. ADD STORIES</Divider>

                <Row gutter={16} className='mb-3'>
                    <Col span={12}>
                        <AutoComplete
                            style={{ width: 200 }}
                            options={stories.filter(item => !collectionStories.map(s => s.id).includes(item.id)).map(s => ({ ...s, value: s.name }))}
                            placeholder="Input story name"
                            filterOption={(inputValue, option) =>
                                option!.name.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                            }
                            onSelect={(value, option) => handleSelectStory(value, option as StoryModel)}
                        />
                    </Col>
                </Row>
                
                <Row>
                    <Table
                        loading={false}
                        rowKey={"noNumber"}
                        className="table table-hover m-0 table-centered dt-responsive nowrap w-100"
                        dataSource={collectionStories}
                        columns={columns}
                        pagination={false}
                    />
                </Row>
            </Form>
        </Drawer>
    )

}

export default StoryCollectionDrawer;
